import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse } from '_helpers';
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
} from "reactstrap";

import TSListNetworkHosp from "../components/Forms/TSListNetworkHosp.js";

// core components
import TSText from "components/Forms/TSText.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSNavbar from "../components/Navbars/TSNavbar.js";


//function Admin() {
const ReportPage = (props) => {
    const ServiceType = (props.match.params.ServiceType !== undefined) ? props.match.params.ServiceType : null;
    const [renderItem, setRenderItem] = useState([]);
    const [pills, setPills] = useState("2");
    const [displayAdd, setDisplayAdd] = useState(false);
    const currentUser = authenticationService.currentUserValue;

    const fetchUser = (keyword) => {

        if (currentUser) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };
            fetch('/api/v1/data/report?PageNumber=1&PageSize=50')
                .then(handleResponse)
                .then(
                    (result) => {
                        setDisplayAdd(result.data.length == 0)
                        setRenderItem(result.data);
                        console.log(result.data);
                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }
    };

    useEffect(() => {
        fetchUser('');
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    },[]);

    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }  if (currentUser.role == null /*|| currentUser.role.substring(0, 2) != 'N_'*/) {
        return <Redirect to={{ pathname: '/home', /*state: { from: props.location }*/ }} />
    }


    const searchKeyword = (e) => {
        if (e.length > 2) {
            fetchUser(e);
        }
        else if (e == '') {
            fetchUser('');
        }
    };

    const content = renderItem.map((post, index) =>
        <Row key={index} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
            <Col md="1" xs="6">
                {post.piNote}
            </Col>
            <Col md="1" xs="6">
                {post.peNote}
            </Col>
            <Col md="2" xs="6">
                {post.nurseNote}
            </Col>
            <Col md="1" xs="6">
                {post.visitKey} ปี
            </Col>
            <Col md="1" xs="6">
                {post.hxNote}
            </Col>
            <Col md="2" xs="12">
                {post.searchCode}
            </Col>
            <Col md="2" xs="12">
                {post.rosNote}
            </Col>
            <Col md="2" xs="12">
                {post.ccNote}
            </Col>
        </Row>
    );


    return (
        <>
            <TSNavbar />
            <div className="wrapper">
                <TrangskinPageHeader2 />
                <div className="section" style={{ padding: '0' }}>
                    <Container>
                        <h3 className="title">ข้อมูลผู้ป่วยสะเก็ดเงินจังหวัดกระบี่</h3> 
                        <div /*style={{ backgroundColor: '#2ca8ff1f' }}*/>
                            {/* <Row>
                                <Col className="text-center ml-auto mr-auto" lg="6" sm="12">
                                    <TSText name="Keyword" placeholder="ค้นหา ชื่อ, เลขบัตรประชาชน (ค้นหาก่อนลงทะเบียนใหม่)" onChange={e => searchKeyword(e.target.value)} icon="tech_mobile" />
                                </Col>     
                            </Row> */}
                            {/* {(displayAdd) ?
                            <Row className="send-button">
                                <Col className="text-center ml-auto mr-auto" lg="6" sm="12">
                                    <Button
                                        block
                                        className="btn-round"
                                        color="info"
                                        onClick={() => {
                                                const { from } = props.location.state || { from: { pathname: "/hospital/register" } };
                                                props.history.push(from);
                                            }
                                        }
                                        size="lg"
                                    >
                                        ลงทะเบียนผู้ป่วย
                                    </Button>
                                </Col>
                            </Row> : ""
                            } */}
                            <Row style={{ fontWeight: 'bold', fontSize: '1em', padding: '10px 10px', borderBottom: '2px solid #dddddd' }}>
                                <Col md="1" xs="6" className="d-none d-sm-block">
                                    วันที่
                                </Col>
                                <Col md="1" xs="6" className="d-none d-sm-block">
                                    HN
                                </Col>
                                <Col md="2" xs="6" className="d-none d-sm-block">
                                    ชื่อ-นามสกุล
                                </Col>
                                <Col md="1" xs="6" className="d-none d-sm-block">
                                    อายุ
                                </Col>
                                <Col md="1" xs="6" className="d-none d-sm-block">
                                    รหัสโรค
                                </Col>
                                <Col md="2" xs="12" className="d-none d-sm-block">
                                    ยา
                                </Col>
                                <Col md="2" xs="12" className="d-none d-sm-block">
                                    ที่อยู่
                                </Col>
                                <Col md="2" xs="12" className="d-none d-sm-block">
                                    CCNote
                                </Col>
                            </Row>
                            {content}
                        </div>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default ReportPage;

